import {
  CssBaseline,
  GlobalStyles,
  ThemeProvider as MuiThemeProvider,
} from '@mui/material';
import React from 'react';
import { ThemeProvider as LegacyThemeProvider } from 'styled-components';
import { theme } from 'constants/theme';
import { isApp } from 'utils/app';
import useNewTheme, { breakpoints } from './useNewTheme';

function AppThemeProvider(props) {
  const { children } = props;
  const muiTheme = useNewTheme();
  return (
    <MuiThemeProvider theme={muiTheme}>
      <LegacyThemeProvider theme={theme}>
        {children}
      </LegacyThemeProvider>
      <CssBaseline />
      <GlobalStyles
        styles={{
          html: {
            // scrollBehavior: 'smooth',
          },
          a: {
            textDecoration: 'none',
            ...(isApp()
              ? {
                '-webkit-touch-callout': 'none',
              }
              : {}),
          },
          [muiTheme.breakpoints.down('md')]: {
            '.crisp-client div a[data-is-failure][aria-label][data-maximized]':
                              {},
          },
        }}
      />
    </MuiThemeProvider>
  );
}

AppThemeProvider.useNewTheme = useNewTheme;
AppThemeProvider.breakpoints = breakpoints;

export default AppThemeProvider;
